/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-08 16:29:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-07 11:31:43
 */
import {notification, Popover} from "antd";
import moment from 'moment'
import { duration } from "moment";
import React from "react";
import { EditableColumnType } from "../../compnents/list/EditableList";
import { Dimen } from "../../models/dimen";
import {InfoCircleTwoTone} from "@ant-design/icons";
import { DateTimeFormatSimple, DateTimeFormatSimpleOnly } from "../../models/datetime";
import { useSelector } from "react-redux";
import { selectSettings } from "../user/setting/settingSlice";
import { Checks } from "../../models/setting";
import styles from "./InventoryStock.module.css";

// 库存盘点
export const InventoryCloumn = (
  storehouseTag: number,
  onclick: (text: string, t: any) => void,
  startIndex: number,
  sortedInfo?: any,
  KFGZZCKLRSJData?: any,
  dataList?: any[]
): EditableColumnType<any>[] => {
  const settings = useSelector(selectSettings)

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''
    const spec = item.spec ? item.spec : '-'
    const deadline = item.deadline ? moment(item.deadline).format(DateTimeFormatSimpleOnly) : '-'

    console.log(materialsCategory,item,model,"modelmodel")
    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        //生产厂家 + 有效期 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + deadline + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        //生产厂家 + 有效期 + 包装规格 + 型号
        return tenantSupplierName + '/' + deadline + '/' + packSpec + model
      } else {
        //生产厂家 + 有效期 + 包装规格
        return tenantSupplierName + '/' + deadline + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        //生产厂家 + 有效期 + 规格 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + deadline + '/' + spec + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        //生产厂家 + 有效期 + 规格 + 型号
        return tenantSupplierName + '/' + deadline + '/' + spec + model
      } else {
        //生产厂家 + 有效期 + 规格 
        return tenantSupplierName + '/' + deadline + '/' + spec 
      }
    }
  }

  return [
    {
      title: '序号',
      width: Dimen.Num,
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '产品信息',
      dataIndex: 'productInfo',
      width: '20rem',
      ellipsis: true,
      render: function Element(_, record) {
        return (
          <Popover
            content={
              <div style={{ maxWidth: '400px' }}>
                <p
                  className={styles.popoverNameText}
                >
                  {record.name}
                </p>
                <p
                  className={styles.popoverProductText}
                >
                  {getProcuctInfo(record)}
                </p>
              </div>
            }
            placement='bottom'
          >
            <div style={{ maxWidth: '500px' }}>
              <p
                className={styles.nameText}
              >
                {record.name}
              </p>
              <p
                className={styles.productText}
              >
               {getProcuctInfo(record)}
              </p>
            </div>
          </Popover>
        )
      },
    },
    {
      title: '批次号',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'batchNo',
    },
    {
      title: '有效期',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'deadline',
      render: (_, t) => {
        return t.deadline &&
          t.deadline !== undefined &&
          t.deadline !== '' &&
          t.deadline !== 'Invalid date'
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '柜号',
      key: 'cabineNo',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      sorter: true,
      dataIndex: 'cabineNo',
      sortOrder: sortedInfo?.columnKey === 'cabineNo' && sortedInfo?.order,
    },
    {
      title: '拆零比例',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'splitScale',
    },
    {
      title: '拆零数',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'splitCount',
      render: function Element(_, t) {
        return (
          <div style={{ color: '#999999' }}>
            {t.splitCount}{t.splitUnit ? t.splitUnit : ''}
          </div>
        )
      },
    },
    {
      title: '实际拆零数',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'realSplitCount',
      nextDataIndex: 'realCount',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/),
          message: '请输入数字',
        },
      ],
      render: function Element(_, t) {
        let color = '#999999'
        if (t.tenantInventoryReceiptItemId > 0) {
          color = t.realSplitCount !== t.splitCount ? '#FA8714' : '#027AFF'
        }
        return (
          <div style={{ color: color}}>
            {t.realSplitCount}{t.splitUnit ? t.splitUnit : ''}
          </div>
        )
      },
      onSave: (oldrow, next) => {
        const prev = {
          ...oldrow,
          productInfo: `${oldrow.name} /${oldrow.tenantSupplierName} /${oldrow.spec} /${oldrow.doseCategory}`,
        }
        if (prev.splitTag === 1) {
          onclick('submit', { prev, next })
        } else {
          notification.error({
            message: '该药品不支持拆零',
            duration: 3,
          })
        }
      },
    },
    {
      title: '账簿数',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'count',
      render: function Element(_, t) {
        return (
          <div style={{ color: '#999999' }}>
            {t.count}{t.accountUnit ? t.accountUnit : ''}
          </div>
        )
      },
    },
    {
      title: '实际数',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'realCount',
      dataList: dataList,
      inputType: 'realCount',
      nextDataIndex: 'realCount',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          // pattern: new RegExp(/^[0-9]\d*$/),
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/),
          message: '请输入数字',
        },
      ],
      render: function Element(_, t) {

        let color = '#999999'
        if (t.tenantInventoryReceiptItemId > 0) {
          color = t.realCount !== t.count ? '#FA8714' : '#027AFF'
        }
        return (
          <div style={{ color: color }}>
            {t.realCount}{t.accountUnit ? t.accountUnit : ''}
          </div>
        )
      },
      onSave: (oldrow, next) => {
        const prev = {
          ...oldrow,
          productInfo: `${oldrow.tenantSupplierName} /${oldrow.packSpec} /${oldrow.doseCategory}`,
        }
        if (next.realCount) {
          onclick('submit', { prev, next })
        }
      },
    },
    {
      title: '盘盈盘亏数',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: '',
      render: (_, t) => {
        return isNaN(t.realCount - t.count)
          ? ''
          : (t.realCount - t.count).toFixed(2) + (t.accountUnit ? t.accountUnit : '')
      },
    },
    {
      title: '盘盈盘亏数(拆零)',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: '',
      render: (_, t) => {
        return isNaN(t.realSplitCount - t.splitCount)
          ? 0
          : (t.realSplitCount - t.splitCount).toFixed(2) + (t.splitUnit ? t.splitUnit : '')
      },
    },
    {
      title: '变动金额(进价)',
      align: 'right',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'totalPrice',
      render: (_, t) => {
        return !KFGZZCKLRSJData ? '***' : (isNaN(
          (t.realSplitCount - t.splitCount) * t.splitPrice +
          (t.realCount - t.count) * t.unitPrice
        )
          ? ''
          : (
            (t.realSplitCount - t.splitCount) * t.splitPrice +
            (t.realCount - t.count) * t.unitPrice
          ).toFixed(2))
      },
    },
  ]
};
